/* Custom JS for Omnia */

document.addEventListener('DOMContentLoaded', function() {
  // Color Swatch Interaction on Product Cards
  const swatches = document.querySelectorAll('.swatch');
  
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      const parentCard = this.closest('.card-wrapper');
      if (!parentCard) return;

      const newImageUrl = this.dataset.imageUrl;
      const mainImage = parentCard.querySelector('.card__inner img');

      if (mainImage && newImageUrl) {
        mainImage.srcset = newImageUrl;
        mainImage.src = newImageUrl;
      }

      // Update active state
      parentCard.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Shipping Progress Bar Logic
  function updateShippingTracker() {
    const cartTracker = document.querySelector('.shipping-tracker__progress-fill');
    if (!cartTracker) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const total = cart.total_price / 100;
        const threshold = 3000;
        const percentage = Math.min((total / threshold) * 100, 100);
        
        cartTracker.style.width = percentage + '%';
        
        const messageElement = document.querySelector('.shipping-tracker__message');
        if (messageElement) {
          if (total >= threshold) {
            messageElement.innerText = "Congratulations! You've unlocked FREE shipping!";
          } else {
            const remaining = threshold - total;
            messageElement.innerText = `Add ₹${remaining.toFixed(2)} more for FREE shipping!`;
          }
        }
      });
  }

  // Update on cart changes
  document.addEventListener('cart:updated', updateShippingTracker);
  updateShippingTracker();

  // Header Transparency on Scroll
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper && document.body.classList.contains('template-index')) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        headerWrapper.classList.add('header-wrapper--scrolled');
      } else {
        headerWrapper.classList.remove('header-wrapper--scrolled');
      }
    });
  }
});
